// extracted by mini-css-extract-plugin
export default {"paymentSection":"J--z","disabled":"K--z"};